
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6Wja6", function(module, exports) {

$parcel$export(module.exports, "useIsDropdownOpen", () => $bb883726a7566904$export$f23a75298e125425);
$parcel$export(module.exports, "default", () => $bb883726a7566904$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");

var $1XJ20 = parcelRequire("1XJ20");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $iwkYX = parcelRequire("iwkYX");
const $bb883726a7566904$export$f23a75298e125425 = (isOpen = false)=>(0, $5uXOq.useState)(isOpen);
const $bb883726a7566904$var$entryPointParams = {};
const $bb883726a7566904$var$CreatePullRequestDropdown = ({ createPullRequestTargets: createPullRequestTargets, renderDropdownTrigger: renderDropdownTrigger, onOpenDropdown: onOpenDropdown, hasErrors: hasErrors, onAuthErrorClick: onAuthErrorClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = $bb883726a7566904$export$f23a75298e125425();
    const wasOpen = (0, $1XJ20.usePreviousWithInitial)(isOpen);
    (0, $5uXOq.useEffect)(()=>{
        if (wasOpen !== isOpen) {
            isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'createPullRequestDropdown');
            !isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'createPullRequestDropdown');
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        wasOpen,
        isOpen,
        onOpenDropdown
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $iwkYX.createPullRequestDropdownContentEntrypoint), $bb883726a7566904$var$entryPointParams);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            createPullRequestTargets: createPullRequestTargets,
            hasErrors: hasErrors,
            onAuthErrorClick: onAuthErrorClick,
            setIsOpen: setIsOpen
        }), [
        hasErrors,
        createPullRequestTargets,
        onAuthErrorClick,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        id: "create-pull-request-dropdown",
        testId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.popup",
        messageId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.popup",
        messageType: "transactional",
        zIndex: (0, $gwIPs.layers).modal + 1,
        placement: "bottom-end",
        shouldFlip: true,
        trigger: (triggerProps)=>renderDropdownTrigger({
                ...triggerProps,
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen)
            }),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "dev-panel-create-pull-request-content",
                packageName: "jira-development-summary-branch",
                fallback: null,
                runtimeProps: runtimeProps
            })
    });
};
var $bb883726a7566904$export$2e2bcd8739ae039 = $bb883726a7566904$var$CreatePullRequestDropdown;

});
parcelRegister("iwkYX", function(module, exports) {

$parcel$export(module.exports, "createPullRequestDropdownContentEntrypoint", () => $b75ae57e886fe184$export$179206df5d8714a6);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b75ae57e886fe184$export$179206df5d8714a6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("awr9e")), {
        moduleId: "2568e86a"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("awr9e", function(module, exports) {

let $7a91f38fa4e0bdc0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a91f38fa4e0bdc0$var$load("jYY69").then(()=>parcelRequire('6EcmX'));

});




//# sourceMappingURL=create-pull-request-dropdown.cf84092c.js.map
